!function($, window, document) {
    $(window), $(document), $(document.body);
    let headerHeight = 0, footerHeight = 0;
    function checkVisibility() {
        var windowHeight = $(window).height(), windowTop = $(window).scrollTop(), windowBottom = windowTop + windowHeight;
        $(".js-roll-up, .js-scale-in").each((function() {
            var element = $(this), elementTop = element.offset().top, elementBottom = elementTop + element.outerHeight(), triggerPoint = .05 * windowHeight;
            elementTop <= windowBottom - triggerPoint && elementBottom >= windowTop + triggerPoint && element.addClass("visible");
        }));
    }
    $(".js-anchor").on("click", (function(e) {
        e.preventDefault();
        var target = $(this).attr("href"), offset = $(target).offset().top;
        $("html").animate({
            scrollTop: offset
        }, 200);
    }));
    let play_video_observer = new IntersectionObserver((function(entries, observer) {
        entries.forEach((function(video) {
            let video_element = video.target;
            video.isIntersecting ? video_element.play() : video_element.pause();
        }));
    })), load_video_observer = new IntersectionObserver((function(entries, observer) {
        entries.forEach((function(video) {
            let video_element = video.target;
            if (video.isIntersecting) {
                for (let source in video_element.children) {
                    let video_source = video_element.children[source];
                    "string" == typeof video_source.tagName && "SOURCE" === video_source.tagName && (video_source.src = video_source.dataset.src);
                }
                video_element.classList.remove(".js-lazy-load-video"), load_video_observer.unobserve(video_element), 
                function loadInlineVideo(video) {
                    video.load(), video.addEventListener("canplay", (event => {
                        play_video_observer.observe(video);
                    }));
                }(video_element);
            }
        }));
    }));
    function chechHeaderFooterHeights() {
        headerHeight = $(".header").outerHeight() || 0, footerHeight = $(".footer").outerHeight(), 
        $("body").css({
            "--header-height": headerHeight + "px",
            "--footer-height": footerHeight + "px"
        });
    }
    $("html").addClass("loaded"), chechHeaderFooterHeights(), function initInlineVideos() {
        let $videos = $(".js-lazy-load-video");
        0 != $videos.length && $videos.each((function() {
            load_video_observer.observe(this);
        }));
    }(), setTimeout((function() {
        checkVisibility();
    }), 500), $(window).on("load resize", (function() {
        chechHeaderFooterHeights();
    })).on("scroll", (function() {
        checkVisibility();
    }));
}(jQuery, window, document);